export default class EventsFiltersModel {
  constructor(props) {
    this.Name = props?.Name || "";
    this.ClubVenue = props?.ClubVenue || "";
    this.Fleet = props?.Fleet || "";
    this.Date = props?.Date || null;
  }
}
